/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutRecipientPolicy = typeof OrgSettingsPutRecipientPolicy[keyof typeof OrgSettingsPutRecipientPolicy] | null;


export const OrgSettingsPutRecipientPolicy = {
  invited_members: 'invited_members',
  project_members: 'project_members',
  initiator: 'initiator',
} as const;
